// src/showNavlinksSlice.js

import { createSlice } from '@reduxjs/toolkit';

const showNavlinksSlice = createSlice({
  name: 'showNavlinks',
  initialState: { value: true }, // Default state is true
  reducers: {
    toggleNavlinks: (state) => {
      state.value = !state.value; // Toggle the state
    },
    setNavlinksState: (state, action) => {
      state.value = action.payload; // Set the state to a specific value (true or false)
    },
  },
});

export const { toggleNavlinks, setNavlinksState } = showNavlinksSlice.actions;

export default showNavlinksSlice.reducer;
